import React from 'react';
import TicketSelectOption from './TicketSelectOption';

const TicketMerchantSelect = ({ search, onSearch, matchesSelection, options, onSelect, disabled, loading, optional, children }) => (
  <div>
    <label htmlFor="create-ticket-merchant" className="ticket-create-label">Merchant{optional ? ' (Optional)' : ''}</label>
    <div style={{ position: 'relative' }}>
      <input id="create-ticket-merchant" className="input" value={search} onChange={event => onSearch(event.target.value)}
        placeholder="Search merchant by name or code..." disabled={disabled} aria-busy={loading} />
      {search.trim() && !matchesSelection && (
        <div style={{ position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, zIndex: 30, display: 'grid', gap: '0.25rem', maxHeight: '260px', overflowY: 'auto', padding: '0.35rem', border: '1px solid var(--border-light)', borderRadius: '8px', backgroundColor: 'var(--bg-card)', boxShadow: '0 12px 28px rgba(var(--neutral-rgb), 0.12)' }}>
          {loading ? <div role="status" style={{ padding: '0.65rem 0.75rem', color: 'var(--text-muted)', fontSize: '0.82rem' }}>Loading merchants...</div>
            : options.length ? options.slice(0, 10).map(merchant => (
              <TicketSelectOption key={merchant._id} disabled={disabled} onClick={() => onSelect(merchant)}
                label={merchant.name || merchant.merchant_code} description={merchant.merchant_code || merchant.client_code || 'No code'} />
            )) : <div style={{ padding: '0.65rem 0.75rem', color: 'var(--text-muted)', fontSize: '0.82rem' }}>No merchant matches this search.</div>}
        </div>
      )}
    </div>
    {children}
  </div>
);

export default TicketMerchantSelect;
